import { isBlockSuppressed, type CourseBlock } from '@course-authoring/shared-types';
import type { ContentState } from '../store/editorStore';

/**
 * Convert a fetched lesson ContentState to the learner shape: account reads
 * always return the editor shape (client-suppressed blocks included, flagged
 * via customizationState/renderState), so anything learner-facing — the course
 * learner preview and export/deploy package builds — must drop suppressed
 * blocks and strip the client-context provenance markers before use.
 */
export function toLearnerContentState(state: ContentState): ContentState {
  const blocks: Record<string, CourseBlock> = {};
  const blockOrder: string[] = [];

  for (const blockId of state.blockOrder) {
    const block = state.blocks[blockId];
    if (!block || isBlockSuppressed(block)) continue;
    const learnerBlock = { ...block };
    delete learnerBlock.customizationState;
    delete learnerBlock.renderState;
    delete learnerBlock.clientAdded;
    blocks[blockId] = learnerBlock;
    blockOrder.push(blockId);
  }

  return {
    lessonMeta: state.lessonMeta,
    blocks,
    blockOrder,
  };
}
